module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Share-0bc245eb1f79de547626a463e6b0fe03.svg";